import { isMobile } from "@stacks/connect";
import { Config } from "../config";
import http, { farmHttp } from "../utils/axiosProvider";

export class FarmService {
  async saveTransaction (data) {
    const payload = {
      "publicAddress": data.publicAddress,
      "tokenSymbol": data.tokenSymbol,
      "tokenContractAddress": data.tokenContractAddress,
      "tokenQuantity": String(data.tokenQuantity),
      "status": "success",
      "transactionHash": data.transactionHash,
      "txResponse": data.txResponse,
      "walletInUse": data.walletInUse || 'hiro',
      "txType": data.txType,
      "deviceType": isMobile() ? 'mobile' : 'web',
    };
    await farmHttp.post('/farm/transactions', payload);
  }
}

export default new FarmService();
